import { render, staticRenderFns } from "./page-duty-view.vue?vue&type=template&id=554723f0&scoped=true&"
import script from "./page-duty-view.vue?vue&type=script&lang=js&"
export * from "./page-duty-view.vue?vue&type=script&lang=js&"
import style0 from "./page-duty-view.vue?vue&type=style&index=0&id=554723f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554723f0",
  null
  
)

export default component.exports